import React, { ReactElement } from 'react'
import { BasicTeaserProps, TeaserTypes } from '../../TeaserInterface'
import BigListTeaserArticleImage from './Article'
import BigListTeaserGalleryImage from './Gallery'
import BigListTeaserVideoImage from './Video'

type BigListTeaserImageProps = BasicTeaserProps & {
    /** Type determines the existance of label, duration and playIcon on the image
     * ARTICLE type contains none but just image
     */
    type: TeaserTypes
}

const BigListTeaserImage = ({
    type,
    mainImageUrl,
    mainImageAlt,
    labels,
    videoDuration,
}: BigListTeaserImageProps): ReactElement => {
    const commonProps = {
        mainImageUrl,
        mainImageAlt,
    }
    if (type === 'VIDEO') {
        return (
            <BigListTeaserVideoImage
                videoDuration={videoDuration}
                labels={labels}
                {...commonProps}
            />
        )
    } else if (type === 'GALLERY') {
        return <BigListTeaserGalleryImage {...commonProps} />
    }
    return <BigListTeaserArticleImage {...commonProps} />
}

export default BigListTeaserImage
